<div data-test="hYkAvoRI" class="header">
  <div data-test="UuP5EV0-" class="header__container">
    <div
      data-test="6IwAzQ-L"
      class="header__wrap row align-items-center flex-nowrap gutters-20"
    >
      <div data-test="Uwctu2OT" class="header__col col-auto">
        <button
          data-test="hi0IdaBv"
          class="header__button header__close"
          (click)="close()"
        >
          <i data-test="Ywd4REZe" class="material-icons md-24">close</i>
          <span data-test="-0-EjpAc" class="header__close-text">Close</span>
        </button>
      </div>
      <div data-test="4SLqxif9" class="header__col col">
        <div data-test="McUAmk2a" class="header__left">
          <div data-test="TrMLMkcs" class="row gutters-16 align-items-center">
            <div data-test="VW88SEM4" class="col-auto">
              <div data-test="UnBPlxl9" class="header__details">
                <div data-test="SzWrNzrQ" class="row">
                  <div data-test="ReZTXvMI" class="col-auto">
                    <h2 data-test="SGOEkel9" class="header__details-name">
                      <ng-container *ngIf="!showNewUserTitle(); else newUser">
                        {{ form.value.title ? form.value.title + '.' : '' }}
                        {{ form.value.firstName }}
                        {{ form.value.lastName }}
                      </ng-container>
                      <ng-template #newUser>New user</ng-template>
                    </h2>
                    <div data-test="SX5xWzCg" class="header__details-label">
                      <div
                        data-test="J0MNW1x_"
                        class="label mr-2 label_blue pointer"
                        *ngFor="let roleUnit of getRoles()"
                      >
                        <span data-test="-9RdN41S">{{ roleUnit.role.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-test="ypLl9aWM" class="header__col col-auto">
        <div data-test="z6r4qCMr" class="row align-items-center gutters-16">
          <div
            data-test="l30jx5BH"
            *ngIf="user?.status && user?.status !== userStatuses.DRAFT"
            class="col-auto align-self-center text-right"
          >
            <div data-test="G1JCFaq5" class="text-small text-light">Member since</div>
            <div data-test="ify_i5Es" class="text-small font-weight-bold text-dark">
              {{ user?.createdAt | formatDate }}
            </div>
          </div>
          <div data-test="jFxyJQ9L" class="col-auto">
            <button
              data-test="whR7A7yZ"
              *ngIf="
                user?.status === userStatuses.DRAFT && userPermissions.OBJECTS_USER_EDIT
              "
              class="header__button button button_sm button_white underline no-shadow"
              (click)="exit()"
            >
              <span data-test="7iloTgqO">Save &amp; exit</span>
            </button>
            <md-save-button
              data-test="RLtvKV5a"
              *ngIf="
                user?.status !== userStatuses.DRAFT && userPermissions.OBJECTS_USER_EDIT
              "
              (save)="save()"
              [disabledButton]="form.isValidationPending"
              [isDirty]="form.isDirty"
              [isNew]="!user?.uuid"
            ></md-save-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div data-test="1ZancUF0" class="subheader subheader_edit">
  <div data-test="mzH_jTBD" class="subheader__container">
    <div data-test="OjxFDlSj" class="subheader__wrap row flex-nowrap">
      <div data-test="HzthZVQn" class="subheader__col col-auto mr-auto pr-0">
        <div data-test="5ii-nxhv" class="subheader__tabs">
          <div data-test="LY8jhSuO" class="tabs tabs_uppercase">
            <div data-test="QTpDikzV" class="tabs__wrap">
              <div
                data-test="ursH5Q1M"
                class="tabs__line"
                [ngStyle]="{
                  width: width + 'px',
                  transform: 'translateX(' + translateX + 'px)'
                }"
              ></div>
              <div
                data-test="h8HMOvTJ"
                #generalTab
                (click)="setActiveTab(tabs[0], $event)"
                class="tabs__item"
                [class.active]="currentTab.name === tabsTypes.GENERAL"
              >
                GENERAL
              </div>
              <div
                data-test="7ywsVxc2"
                #permissionsTab
                (click)="setActiveTab(tabs[1], $event)"
                class="tabs__item"
                [class.active]="currentTab.name === tabsTypes.PERMISSIONS"
              >
                PERMISSIONS
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-test="SZ0SvLDP" class="subheader__col col-auto">
        <ng-container
          *ngIf="user?.status === userStatuses.DRAFT && currentTab.nextTabName"
        >
          <button
            data-test="mxBRh2GM"
            (click)="nextTab()"
            class="subheader__button button button_sm button_primary text-uppercase text-left"
          >
            <span data-test="enG1mwvw" class="button__label">Next step</span>
            <span data-test="PUaTWlnS">{{ currentTab.nextTabName }}</span>
            <span data-test="AK42wBh0" class="button__icon button__icon_right">
              <i data-test="hkd5NZHC" class="material-icons md-16">
                keyboard_arrow_right
              </i>
            </span>
          </button>
        </ng-container>
        <button
          data-test="TLo_Wsh_"
          class="subheader__button button button_sm button_primary text-uppercase text-left"
          *ngIf="user?.status === userStatuses.DRAFT && !currentTab.nextTabName"
          (click)="sendInvite()"
          [mdButtonSpinner]="sendingInvitation"
          [disabled]="!user?.roleUnits?.length"
        >
          <span data-test="uTTbqSEL">Send invite</span>
          <span data-test="u_zdoDQl" class="button__icon button__icon_right">
            <i data-test="xVofzpY7" class="material-icons md-16">keyboard_arrow_right</i>
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
